import {axiosReqGet, axiosReqOther} from "./config";
import { store } from '../store/store';

const USER_TOKEN = store.getState().authentication.user;

export const Property = {
    // getPropertyTypes,
    getProperty,
    getSelfProperties,
    getRentedProperties,
    getPropertiesForSale,
    getRelatedProperties,
    getFeaturedProperties,
    getFeaturedPropertiesWithPagination,
    getLatestProperties,
    searchProperties,
    updateProperty
}

// function getSelfProperties(){
//     const url = 'property-types/index.json';
//     return axiosReqGet()
//             .get(url)
//             .then(res => {
//             return res; 
//         })
//         .catch(err => { 
//             alert(err.response.data.message)      
//             return err; 
//         })
// }

/**
 * getProperty
 * get Property Detail
 * @param {*string} email 
 */
function getProperty(data) {
    
    const url = `property/detail.json?property=${data.property}`;
   
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}
/**
* updateProperty
* update Property 
* @param {data}  
*/
function updateProperty(data) {
   
   const url = `property/update-property.json`;
  
   return axiosReqOther(url, data, 'post').then(res => {              
       return res;       
   })
   .catch(err => { 
       return err; 
   });
}
/**
* getProperty
* get Property Detail
* @param {*string} email 
*/
function getSelfProperties(data) {
   
   const url = `property/self-listing.json`;
  
   return axiosReqOther(url, data, 'post').then(res => {              
       return res;       
   })
   .catch(err => { 
       return err; 
   });
}

/**
* getRentedProperties
* get Rented Properties
* @param {*string} email 
*/
function getRentedProperties(data) {
   
   const url = `property/get-rented-properties.json`;
  
   return axiosReqOther(url, data, 'post').then(res => {              
       return res;       
   })
   .catch(err => { 
       return err; 
   });
}

/**
* getPropertiesForSale
* get Sale Properties
* @param {*string} email 
*/
function getPropertiesForSale(data) {
   
    const url = `property/get-properties-for-sale.json`;
   
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

/**
* getRelatedProperties
* get related Properties
* @param {*string} email 
*/
function getRelatedProperties(data) {
   
    const url = `property/related-properties.json`;
   
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

/**
* getRelatedProperties
* get related Properties
* @param {*jsong} data 
*/
function getFeaturedProperties(data) {
   
    const url = `property/featured-properties.json`;
   
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

/**
* getFeaturedPropertiesWithPagination
* get related Properties
* @param {*jsong} data 
*/
function getFeaturedPropertiesWithPagination(data) {
   
    const url = `property/get-featured-properties.json`;
   
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

/**
* getLatestProperties
* get latest Properties
* @param {*jsong} data 
*/
function getLatestProperties(data) {
   
    const url = `property/latest-properties.json`;
   
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

/**
* searchProperties
* filter Properties
* @param {*jsong} data 
*/
function searchProperties(data) {
   
    const url = `property/search-properties.json`;
   
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

export default Property;